import { useQuery } from '@tanstack/react-query';
import { z } from 'zod';
import { Post } from '../cases/cases';
/**
 * The home page's "The community, right now" widget's read shape.
 * Mirrors the backend's `CommunityFeed`: latest posts across every room
 * the caller has joined, plus the follow count for the caption.
 */
export const CommunityFeed = z.object({
    items: z.array(Post),
    roomsFollowing: z.number().int().nonnegative(),
    /**
     * "~80 members online" — and the WINDOW travels with the count.
     *
     * "Online" over fifteen minutes and over a day are different claims, and a
     * bare number would leave the client remembering which one this is. Derived
     * from `last_seen_at` (written on sign-in and on every token refresh), so it
     * is a recency count and not live presence — which is why the design writes
     * it with a `~`. Counts PEOPLE, not memberships.
     */
    membersOnline: z
        .object({
        count: z.number().int().nonnegative(),
        minutes: z.number().int().positive(),
    })
        .optional(),
});
/**
 * Fetch the home community feed.
 *
 * Home is a glance, not a backlog — the server returns at most a handful
 * of posts and this hook stays a plain `useQuery` (no paging, no fetch-
 * next-page). A one-minute `staleTime` lets a member switch tabs and back
 * without re-fetching, but is short enough that a new reply appears the
 * next time they open the app.
 */
export function useCommunityFeed(http) {
    return useQuery({
        queryKey: ['me', 'community-feed'],
        queryFn: () => http.get('/me/community/feed', { schema: CommunityFeed }),
        staleTime: 60_000,
    });
}
//# sourceMappingURL=feed.js.map